// Unauthorized means almost certainly you need to log in:
export function isUnauthorized(error) {
  const status = error.rawResponse && error.rawResponse.status;
  return status === 401;
}

// Forbidden means almost certainly you're not an account owner:
export function isForbidden(error) {
  const status = error.rawResponse && error.rawResponse.status;
  return status === 403;
}